import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariants =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/base_creatives/:campaign_id/variants";

export const decisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariantsCacheKeys: AllRouteEndpoints[] = [
  decisioningStudioAgentsAppGroupIdDsaIdBaseCreativesCampaignIdVariants,
];
